import apiHelper from "./helper";

/**
 * реализуем апи работы с апи востановления/сброса пароля
 */

export const AuthApi = () => {

  const { post } = apiHelper(undefined, false);

  return {

    /**
     * Запрос на сброс пароля
     * @param email {string} - email пользователя
     */
    forgotPassword: async(email: string): Promise<{err?: string, data?: any | null}> =>{
      const { data, err } = await post('auth/forgot-password', { email });
      if (err) return { err };
      return { data };
    },

    /**
     * Запрос на сброс пароля
     * @param code {string} - код подтверждения
     */
    resetPassword: async(code: string, password: string, passwordConfirmation: string): Promise<{err?: string, data?: any | null}> =>{
      const { data, err } = await post('auth/reset-password', { code, password, passwordConfirmation });
      if (err) return { err };
      return { data };
    },
  }
}
